import axios from "axios";
import { objectToFormData } from "../helpers/api";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.timeout = 30000;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = false;

/* --------------------------------------------
						AUTH REQUESTS
-------------------------------------------- */

export const loginRequest = data => {
  return axios
    .post("/sessions", data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const smsLoginRequest = data => {
  return axios
    .post("/sessions/verify", data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const signupRequest = data => {
  return axios
    .post("/users", data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const forgotPasswordRequest = data => {
  return axios
    .post("/users/forgot_password", data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const resetPasswordRequest = data => {
  return axios
    .post("/users/reset_password", data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchUserRequest = ({ user_id, jwt }) => {
  return axios
    .get(`/users/${user_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};


/* --------------------------------------------
					  DEALER REQUESTS
-------------------------------------------- */

export const fetchDealersRequest = jwt => {
  return axios
    .get(`/dealers`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchDealerRequest = (dealer_id, jwt) => {
  return axios
    .get(`/dealers/${dealer_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createDealerRequest = (data, jwt) => {
  return axios
    .post("/dealers", data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateDealerRequest = (dealer_id, data, jwt) => {
  return axios
    .put(`/dealers/${dealer_id}`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  CONTRACT REQUESTS
-------------------------------------------- */

export const fetchCustomerContractsRequest = ({
  dealer_id,
  customer_id,
  jwt
}) => {
  return axios
    .get(`/dealers/${dealer_id}/customers/${customer_id}/contracts`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchContractRequest = ({ dealer_id, contract_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/contracts/${contract_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchContractsRequest = ({
  dealer_id,
  query_string = "",
  jwt
}) => {
  return axios
    .get(`/dealers/${dealer_id}/contracts${query_string}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createContractRequest = ({ dealer_id, data, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/contracts`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateContractRequest = ({
  dealer_id,
  contract_id,
  data,
  jwt
}) => {
  return axios
    .put(`/dealers/${dealer_id}/contracts/${contract_id}`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createPaymentIntentRequest = ({
  dealer_id,
  contract,
  data,
  jwt
}) => {
  return axios
    .post(
      `/dealers/${dealer_id}/contracts/${contract}/payment_intent`,
      data,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

//Parte nueva
export const createPaymentRecorderRequest = ({
  dealer_id,
  contract_id,
  data,
  jwt
}) => {
  return axios
    .post(
      `/dealers/${dealer_id}/contracts/${contract_id}/payment_recorder`,
      data,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  CUSTOMER REQUESTS
-------------------------------------------- */

export const fetchCustomerRequest = ({ dealer_id, customer_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/customers/${customer_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchCustomersRequest = ({ dealer_id, query_string, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/customers${query_string}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createCustomerRequest = ({ dealer_id, data, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/customers`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createCustomerSignupRequest = ({ dealer_id, data }) => {
  return axios
    .post(`/dealers/${dealer_id}/sign_up`, data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateCustomerRequest = ({
  dealer_id,
  customer_id,
  data,
  jwt
}) => {
  return axios
    .put(`/dealers/${dealer_id}/customers/${customer_id}`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  CONTACTS REQUESTS
-------------------------------------------- */

export const fetchContactRequest = ({
  dealer_id,
  customer_id,
  contact_id,
  jwt
}) => {
  return axios
    .get(
      `/dealers/${dealer_id}/customers/${customer_id}/contacts/${contact_id}`,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchContactsRequest = ({ dealer_id, customer_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/customers/${customer_id}/contacts`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createContactRequest = ({ dealer_id, data, customer_id, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/customers/${customer_id}/contacts`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateContactRequest = ({
  dealer_id,
  customer_id,
  contact_id,
  data,
  jwt
}) => {
  return axios
    .put(
      `/dealers/${dealer_id}/customers/${customer_id}/contacts/${contact_id}`,
      data,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const deleteContactRequest = ({
  dealer_id,
  customer_id,
  contact_id,
  jwt
}) => {
  return axios
    .delete(
      `/dealers/${dealer_id}/customers/${customer_id}/contacts/${contact_id}`,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  SCOOTER REQUESTS
-------------------------------------------- */

export const fetchScooterRequest = ({
  dealer_id,
  customer_id,
  scooter_id,
  jwt
}) => {
  return axios
    .get(
      `/dealers/${dealer_id}/customers/${customer_id}/scooters/${scooter_id}`,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchScootersRequest = ({ dealer_id, customer_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/customers/${customer_id}/scooters`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createScooterRequest = ({ dealer_id, customer_id, data, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/customers/${customer_id}/scooters`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateScooterRequest = ({
  dealer_id,
  customer_id,
  scooter_id,
  data,
  jwt
}) => {
  return axios
    .put(
      `/dealers/${dealer_id}/customers/${customer_id}/scooters/${scooter_id}`,
      data,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const deleteScooterRequest = ({
  dealer_id,
  customer_id,
  scooter_id,
  data,
  jwt
}) => {
  return axios
    .delete(
      `/dealers/${dealer_id}/customers/${customer_id}/scooters/${scooter_id}`,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  ITEMS REQUESTS
-------------------------------------------- */

export const fetchItemRequest = ({ dealer_id, contract_id, item_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/contracts/${contract_id}/items/${item_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchItemsRequest = ({ dealer_id, contract_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/contracts/${contract_id}/items`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createItemRequest = ({ dealer_id, contract_id, data, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/contracts/${contract_id}/items`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateItemRequest = ({
  dealer_id,
  contract_id,
  item_id,
  data,
  jwt
}) => {
  return axios
    .put(
      `/dealers/${dealer_id}/contracts/${contract_id}/items/${item_id}`,
      data,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const deleteItemRequest = ({ dealer_id, contract_id, item_id, jwt }) => {
  return axios
    .delete(`/dealers/${dealer_id}/contracts/${contract_id}/items/${item_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  SERVICES REQUESTS
-------------------------------------------- */

export const fetchServiceRequest = ({
  dealer_id,
  contract_id,
  service_id,
  jwt
}) => {
  return axios
    .get(`/dealers/${dealer_id}/services/${service_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchServicesRequest = ({ dealer_id, contract_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/services`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createServiceRequest = ({ dealer_id, contract_id, data, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/services`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateServiceRequest = ({
  dealer_id,
  contract_id,
  service_id,
  data,
  jwt
}) => {
  return axios
    .put(`/dealers/${dealer_id}/services/${service_id}`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const deleteServiceRequest = ({
  dealer_id,
  contract_id,
  service_id,
  jwt
}) => {
  return axios
    .delete(`/dealers/${dealer_id}/services/${service_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  NOTES REQUESTS
-------------------------------------------- */

export const fetchNoteRequest = ({ dealer_id, contract_id, note_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/contracts/${contract_id}/notes/${note_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchNotesRequest = ({ dealer_id, contract_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/contracts/${contract_id}/notes`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createNoteRequest = ({ dealer_id, contract_id, data, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/contracts/${contract_id}/notes`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateNoteRequest = ({
  dealer_id,
  contract_id,
  note_id,
  data,
  jwt
}) => {
  return axios
    .put(
      `/dealers/${dealer_id}/contracts/${contract_id}/notes/${note_id}`,
      data,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const deleteNoteRequest = ({ dealer_id, contract_id, note_id, jwt }) => {
  return axios
    .delete(`/dealers/${dealer_id}/contracts/${contract_id}/notes/${note_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					DISCOUNTS REQUESTS
-------------------------------------------- */

export const fetchDiscountRequest = ({
  dealer_id,
  contract_id,
  discount_id,
  jwt
}) => {
  return axios
    .get(
      `/dealers/${dealer_id}/contracts/${contract_id}/discounts/${discount_id}`,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchDiscountsRequest = ({ dealer_id, contract_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/contracts/${contract_id}/discounts`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createDiscountRequest = ({
  dealer_id,
  contract_id,
  data,
  jwt
}) => {
  return axios
    .post(`/dealers/${dealer_id}/contracts/${contract_id}/discounts`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateDiscountRequest = ({
  dealer_id,
  contract_id,
  discount_id,
  data,
  jwt
}) => {
  return axios
    .put(
      `/dealers/${dealer_id}/contracts/${contract_id}/discounts/${discount_id}`,
      data,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const deleteDiscountRequest = ({
  dealer_id,
  contract_id,
  discount_id,
  jwt
}) => {
  return axios
    .delete(
      `/dealers/${dealer_id}/contracts/${contract_id}/discounts/${discount_id}`,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

/* --------------------------------------------
					  STAFF REQUESTS
-------------------------------------------- */

export const fetchStaffRequest = ({ dealer_id, staff_id, jwt }) => {
  return axios
    .get(`/dealers/${dealer_id}/staff/${staff_id}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const fetchStaffsRequest = ({ dealer_id, jwt, active }) => {
  return axios
    .get(`/dealers/${dealer_id}/staff?active=${active}`, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createStaffRequest = ({ dealer_id, data, jwt }) => {
  return axios
    .post(`/dealers/${dealer_id}/staff`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const updateStaffRequest = ({ dealer_id, staff_id, data, jwt }) => {
  return axios
    .put(`/dealers/${dealer_id}/staff/${staff_id}`, data, {
      headers: {
        Authorization: jwt
      }
    })
    .then(response => ({ response }))
    .catch(function (error) {
      if (error.response) {
        return error
      } else if (error.request) {
        return error.request
      } else {
        return error.message
      }
    })
    // .catch(error => ({ error }));
};

/* --------------------------------------------
					  MARKET REQUESTS
-------------------------------------------- */

export const fetchCategoriesRequest = ({ dealer_id, jwt, query }) =>
  axios({
    method: "get",
    url: `/dealers/${dealer_id}/categories${query}`,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const createCategoryRequest = ({ dealer_id, jwt, data }) =>
  axios({
    method: "post",
    url: `/dealers/${dealer_id}/categories`,
    headers: {
      Authorization: jwt
    },
    data
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const createProductRequest = ({ dealer_id, data, jwt }) =>
  axios({
    method: "post",
    url: `/dealers/${dealer_id}/products`,
    headers: {
      Authorization: jwt
    },
    data: objectToFormData(data)
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const updateProductRequest = ({ dealer_id, productId, data, jwt }) =>
  axios({
    method: "put",
    url: `/dealers/${dealer_id}/products/${productId}`,
    headers: {
      Authorization: jwt
    },
    data: objectToFormData(data)
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const fetchProductsRequest = ({ dealer_id, query }) =>
  axios({
    method: "get",
    url: `/dealers/${dealer_id}/products${query}`
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const fetchProductRequest = ({ dealerId, productId, jwt }) =>
  axios({
    method: "get",
    url: `/dealers/${dealerId}/products/${productId}`,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const deleteProductImageRequest = ({
  dealer_id,
  product_id,
  image_id,
  jwt
}) => {
  return axios
    .delete(
      `/dealers/${dealer_id}/products/${product_id}/images?image_id=${image_id}`,
      {
        headers: {
          Authorization: jwt
        }
      }
    )
    .then(response => ({ response }))
    .catch(error => ({ error }));
};

export const createShoppingCartRequest = ({
  dealerId,
  customerId,
  data,
  jwt
}) =>
  axios({
    method: "post",
    url: `/dealers/${dealerId}/customers/${customerId}/shopping_carts`,
    data,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const addContractShoppingCartRequest = ({
  dealer_id,
  customer_id,
  tracking_number,
  jwt
}) =>
  axios({
    method: "get",
    url: `/dealers/${dealer_id}/customers/${customer_id}/shopping_cart/add_contract/${tracking_number}`,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const createAnonymousShoppingCartRequest = ({ data }) =>
  axios({
    method: "post",
    url: `/shopping_cart`,
    data
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const fetchShoppingCartRequest = ({ dealerId, customerId, jwt }) =>
  axios({
    method: "get",
    url: `/dealers/${dealerId}/customers/${customerId}/shopping_cart`,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const fetchAnonymousShoppingCartRequest = ({ sessionId }) =>
  axios({
    method: "get",
    url: `/shopping_cart/${sessionId}`
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const updateShoppingCartRequest = ({
  dealerId,
  customerId,
  data,
  jwt
}) =>
  axios({
    method: "put",
    url: `/dealers/${dealerId}/customers/${customerId}/shopping_cart`,
    data,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const updateAnonymousShoppingCartRequest = ({ data, sessionId }) =>
  axios({
    method: "put",
    url: `/shopping_cart/${sessionId}`,
    data
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const checkoutShoppingCartRequest = ({
  dealerId,
  customerId,
  data,
  jwt
}) =>
  axios({
    method: "post",
    url: `/dealers/${dealerId}/customers/${customerId}/shopping_cart/register_payment_from_shopping_cart`,
    data,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const fetchDealerShoppingCartsRequest = ({ dealerId, jwt }) =>
  axios({
    method: "get",
    url: `/dealers/${dealerId}/shopping_carts`,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));

export const fetchCustomerShoppingCartsRequest = ({
  dealerId,
  customerId,
  jwt
}) =>
  axios({
    method: "get",
    url: `/dealers/${dealerId}/customers/${customerId}/shopping_carts`,
    headers: {
      Authorization: jwt
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));
